var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"il-header"},[_c('img',{staticClass:"il-img-banner",attrs:{"src":require("../assets/img/il_banner.png"),"alt":"banner"}})])}]

export { render, staticRenderFns }